import React from "react";
import "./Footers.css";
import { FaArrowRight, FaFacebookF, FaYoutube, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import FooterRightImage from '../components/assets/images/footer-right.png'; // Adjust path as needed

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="footer-content">
                    <div className="subscribe">
                        <h3>Stay in Touch</h3>
                        <div className="inputs">
                            <input type="email" placeholder="Email" />
                            <div className="mobile-input">
                                <input type="tel" placeholder="Mobile" />
                                <FaArrowRight />
                            </div>
                        </div>
                        <div className="social-icons">
                            <FaFacebookF />
                            <FaYoutube />
                            <FaInstagram />
                        </div>
                    </div>

                    <div className="links-group">
                        <h4>OUR BEST SELLERS</h4>
                        <ul>
                            <li>Pure Shilajit Resin 10g</li>
                            <li>Pure Shilajit Resin 20g</li>
                            <li>Pure Shilajit Resin 30g</li>
                        </ul>
                    </div>

                    <div className="links-group">
                        <h4>CUSTOMER SERVICES</h4>
                        <ul>
                            <li><Link to="/trackyourorder" className="track-order-link">Track Your Order</Link></li>
                            <li><Link to="/delivery" className="track-order-link">Delivery and Returns</Link></li>
                            <li>Privacy Policy</li>
                            <li><Link to="/faq" className="track-order-link">FAQs</Link></li>

                        </ul>
                    </div>

                    <div className="links-group">
                        <h4>Quick links</h4>
                        <ul>
                            <li><Link to="/about" className="track-order-link">About us</Link></li>
                            <li><Link to="/shilajit" className="track-order-link">Shop by Products</Link></li>

                            <li><Link to="/blogSectionblog" className="track-order-link">Blogs</Link></li>
                            <li><Link to="/contact" className="track-order-link">Contact us</Link></li>
                        </ul>
                    </div>

                    <div className="contact-info">
                        <p><strong>Address</strong><br />
                            -------------------------------------<br />
                        </p>
                    </div>
                </div>

                <img src={FooterRightImage} alt="Decorative Leaves" className="footer-right-image" />
            </div>
            <hr />
            <div className="footer-bottom">
                <div className="footer-links">
                    <Link to="/contact" className="track-order-link">Contact us</Link>
                    <Link to="/delivery" className="track-order-link">Return & Refund policy</Link>
                    <a href="#">Terms & Conditions</a>
                    <a href="#">Privacy Policy</a>
                </div>
                <p className="copyright">
                    Copyright © 2025 --------. All rights reserved
                </p>
            </div>
        </footer>
    );
};

export default Footer;
